import React, { useRef, useState } from 'react'
import {
  Avatar,
  Box,
  ButtonBase,
  Menu,
  MenuItem,
  makeStyles,
  Divider,
  Typography,
} from '@material-ui/core'

import styles from './styles'

import * as services from 'services'

import useAuth from 'hooks/useAuth'

import { routes } from 'Routes'

import { LabelIconStart } from 'components'

import { Settings as SettingsIcon, LogOut as LogOutIcon } from 'react-feather'

const useStyles = makeStyles(styles)

const Account = () => {
  const classes = useStyles()
  const ref = useRef(null)
  const auth = useAuth()
  const [isOpen, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleLogout = () => {
    services.smartRevision.auth.logout()
    services.history.push(routes.root)
  }

  const handleSettings = () => {
    // services.history.push(routes.user.account)
  }

  const avatarLetters = ((auth.user && auth.user.name) || 'Usuário')
    .split(' ')
    .map((word) => word[0])
    .join('')

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <Avatar className={classes.avatar}>
          {avatarLetters[0]}
          {avatarLetters[avatarLetters.length - 1]}
        </Avatar>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        classes={{ list: classes.menuList }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <Box ml={1} my={1} display="flex">
          <Typography variant="subtitle1">Perfil</Typography>
        </Box>
        <Divider />

        <MenuItem onClick={handleSettings}>
          <Box my={1}>
            <LabelIconStart
              variant="inherit"
              icon={<SettingsIcon size="20" />}
              label="Configurações"
            />
          </Box>
        </MenuItem>

        <Divider />
        <MenuItem onClick={handleLogout}>
          <Box my={1}>
            <LabelIconStart
              variant="inherit"
              icon={<LogOutIcon size="20" />}
              label="Sair"
            />
          </Box>
        </MenuItem>
      </Menu>
    </>
  )
}

export default Account
